export default "__VITE_ASSET__B5s7ZoKo__"